import React from "react";
import { NAV_ITEMS } from "../config/siteConfig";
import { scrollToSection } from "../config/utils";

const Footer = () => {
  return (
    <footer className="py-12 bg-black border-t border-white/5">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center text-black font-bold text-sm">
              P
            </div>
            <span
              className="tracking-widest uppercase text-sm font-display"
              style={{ color: "#BB9D63" }}
            >
              Prestige Event
            </span>
          </div>
          <div className="flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.target}
                onClick={() => scrollToSection(item.target)}
                className="text-zinc-600 hover:text-zinc-400 text-xs tracking-wider uppercase transition-colors"
              >
                {item.label}
              </button>
            ))}
          </div>
          <p className="text-zinc-700 text-xs">
            © {new Date().getFullYear()} Prestige Event
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
